<div
  class="table-responsive"
  [formGroup]="form"
  *visible="loadState.isCompleted; transition: 'bounce'"
>
  <table
    mat-table
    [dataSource]="dataSource"
    formArrayName="subjects"
  >
    <ng-container matColumnDef="subject">
      <th mat-header-cell *matHeaderCellDef i18n>מקצוע</th>

      <td mat-cell *matCellDef="let row" [formGroup]="row">
        <mat-form-field floatLabel="never" class="no-hint">
          <mat-label i18n>בחרו מקצוע</mat-label>
          <input
            type="text"
            matInput
            autocomplete="off"
            formControlName="subject"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option
              *ngFor="let subject of filterSubjects(row.value)"
              [value]="subject.subjectName"
            >
              {{ subject?.subjectName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="units">
      <th mat-header-cell *matHeaderCellDef i18n>יחידות לימוד</th>

      <td mat-cell *matCellDef="let row" [formGroup]="row">
        <mat-form-field floatLabel="never" class="no-hint">
          <mat-label i18n>יחידות לימוד</mat-label>
          <input
            matInput
            type="number"
            formControlName="units"
            min="1"
            max="20"
            step="1"
            inputmode="numeric"
            (keydown)="blockNonIntegerKey($event)"
            (input)="sanitizeInteger(row, 'units')"
          />
        </mat-form-field>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <span i18n>סה"כ</span>: {{ totalUnits }}
      </td>
    </ng-container>

    <ng-container matColumnDef="grade">
      <th mat-header-cell *matHeaderCellDef i18n>ציון</th>

      <td mat-cell *matCellDef="let row" [formGroup]="row">
        <mat-form-field floatLabel="never" class="no-hint">
          <mat-label i18n>ציון</mat-label>
          <input
            matInput
            type="number"
            formControlName="grade"
            min="1"
            max="100"
          />
        </mat-form-field>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <span i18n>ממוצע</span>: {{ average | number: '1.0-2' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="bonus">
      <th mat-header-cell *matHeaderCellDef i18n>בונוס</th>

      <td mat-cell *matCellDef="let row" class="table-num">
        {{ row?.value?.bonus | number: '1.0-2' }}
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="final-grade">
      <th mat-header-cell *matHeaderCellDef i18n>ציון סופי</th>

      <td mat-cell *matCellDef="let row" class="table-num table-num--strong">
        {{ row?.value?.finalGrade | number: '1.0-2' }}
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <span i18n>ממוצע משוקלל</span>: {{ weightedAverage | number: '1.0-2' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let row" [formGroup]="row">
        <button
          mat-icon-button
          type="button"
          i18n-matTooltip
          matTooltip="מחק שורה"
          (click)="removeRow(row)"
          [disabled]="!canRemoveRow(row)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayColumns"></tr>
  </table>
</div>
